import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

type Props = {
  onBookingClick?: () => void;
};

const AreasServedSection = ({ onBookingClick }: Props) => {
const cities = [
    // Southwest Michigan - Berrien County Focus
    "Buchanan",
    "Niles",
    "St. Joseph",
    "Benton Harbor",
    "Berrien Springs",
    "Stevensville",
    "Bridgman",
    "New Buffalo",
    "Dowagiac",
    "Edwardsburg",
    "Cassopolis",
    "Three Oaks",
    "Sawyer",
    "Baroda",
    "Coloma",
    "Watervliet",
    "Hartford",
    "Galien",
  ];

  return (
    <section id="areas" className="py-16">
      <div className="container mx-auto px-4">
        <header className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-serif font-light mb-3">Areas We Serve Across Southwest Michigan</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Professional organizing services for Southwest Michigan's communities throughout Berrien County and beyond.
          </p>
        </header>

        <div className="max-w-4xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {cities.map((city) => (
            <Badge key={city} variant="secondary" className="justify-center py-2 text-sm">
              {city}
            </Badge>
          ))}
        </div>

        {onBookingClick && (
          <div className="text-center mt-10">
            <Button onClick={onBookingClick}>Book in Your City</Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default AreasServedSection;
